var lt = Object.defineProperty;
var ft = (n, e, t) => e in n ? lt(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t;
var _ = (n, e, t) => ft(n, typeof e != "symbol" ? e + "" : e, t);
var rt = /* @__PURE__ */ ((n) => (n.CHAT = "CHAT", n.NOTIFICATION = "NOTIFICATION", n.PRODUCTION_NOTE = "PRODUCTION_NOTE", n.SHIPPING_NOTE = "SHIPPING_NOTE", n))(rt || {}), ht = /* @__PURE__ */ ((n) => (n.UP = "UP", n.DOWN = "DOWN", n))(ht || {});
class Kt {
  constructor(e, t) {
    _(this, "axiosInstance");
    _(this, "axiosInstanceJson");
    _(this, "sessionId", "");
    this.axiosInstance = e, this.axiosInstanceJson = t;
  }
  setSessionId(e) {
    this.sessionId = e;
  }
  getPatientsSlim(e, t, r, i = "LAST_MODIFIED", o = "DESC", a = "ALL", s = "", u, f) {
    const l = {
      project_type: e,
      items_per_page: t,
      page: r + 1,
      sortColumn: i,
      sortDirection: o,
      search: s,
      filterPatients: a,
      ...u ? { modifiedFrom: u } : {},
      ...f ? { modifiedTo: f } : {},
      with_files: !0
    };
    return this.axiosInstance.get("/project/slim", {
      params: l
    });
  }
  getPatientFullById(e) {
    return this.axiosInstance.get(`/project/${e}/full`);
  }
  getPatientById(e) {
    return this.axiosInstance.get(`/project/${e}`);
  }
  getPatients() {
    return this.axiosInstance.get("/project");
  }
  getPrescriptionPatients() {
    return this.axiosInstance.get("/project", {
      params: {
        project_type: "prescription"
      }
    });
  }
  getCadLibrariesList() {
    return this.getCadLibrariesListByType("cadteethlibraries");
  }
  getCadLibrariesListByType(e) {
    return this.axiosInstance.get("/cadlibraries/list", {
      params: {
        type: e
      }
    });
  }
  getCadLibrariesFilteredList(e, t, r, i, o) {
    return this.getCadLibrariesFilteredListByType("cadteethlibraries", e, t, r, i, o);
  }
  getCadLibrariesFilteredListByType(e, t, r, i, o, a) {
    const s = {
      type: e,
      modelName: t,
      fileType: r,
      lvlOne: i,
      lvlTwo: o,
      lvlThee: a
    }, u = Object.keys(s).filter((f) => s[f] !== void 0).reduce((f, l) => (f[l] = s[l], f), {});
    return this.axiosInstance.get("/cadlibraries/list/filter", { params: u });
  }
  getCadLibrariesXmlById(e) {
    return this.axiosInstance.get("/cadlibraries/file/" + e);
  }
  getCadLibrariesFileById(e) {
    return this.axiosInstance.get("/cadlibraries/file/" + e, {
      responseType: "arraybuffer",
      headers: {
        Accept: "application/octet-stream"
      }
    });
  }
  triggerDrillReport(e, t) {
    const r = new FormData();
    return r.append("patient_name", e), r.append("file", t), this.axiosInstanceJson.post("/drillReport", r, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  }
  // TODO prior call upload png file with type export_screenshot that will be used for 3D screenshot
  triggerExportJob(e, t, r, i) {
    const o = {
      exportType: t,
      useDicomReferenceSystem: r,
      exportFileName: i
    };
    return this.axiosInstanceJson.post(`/jobs/trigger/export/${e}`, o, {
      headers: {
        Authorization: `Bearer ${this.sessionId}`
      }
    });
  }
  // TODO prior call upload png file with type report_logo that will be used for report logo
  triggerReportJob(e, t, r) {
    const i = {
      exportFileName: t,
      jsonData: r
    };
    return this.axiosInstanceJson.post(`/jobs/trigger/report/${e}`, i, {
      headers: {
        Authorization: `Bearer ${this.sessionId}`
      }
    });
  }
  getJobStatusUuid(e) {
    return this.axiosInstance.get(`/jobs/status/job/${e}`, {
      headers: {
        Authorization: `Bearer ${this.sessionId}`
      }
    });
  }
  getProjectJobStatusUuid(e) {
    return this.axiosInstance.get(`/jobs/status/file/${e}`, {
      headers: {
        Authorization: `Bearer ${this.sessionId}`
      }
    });
  }
  triggerSegmentationJob(e) {
    return this.axiosInstance.get(`/jobs/trigger/segmentation/${e}`, {
      headers: {
        Authorization: `Bearer ${this.sessionId}`
      }
    });
  }
  generateProductionCenterToken(e, t) {
    return this.axiosInstanceJson.get(`/weblink/productionCenter/${e}/apikey`, {
      params: {
        name: t
      }
    });
  }
  getProductionCenterTokenList(e) {
    return this.axiosInstanceJson.get(`/weblink/productionCenter/${e}/apikey/list`);
  }
  revokeProductionCenterToken(e, t) {
    return this.axiosInstance.delete(`/weblink/productionCenter/${e}/apikey`, {
      params: {
        name: t,
        pcid: e
      }
    });
  }
  generateInviteToken(e) {
    return this.axiosInstanceJson.get(`/weblink/productionCenter/${e}/inviteToken/regenerate`);
  }
  claimInviteToken(e) {
    return this.axiosInstanceJson.get("/user/productionCenter/claimInviteToken", {
      params: {
        invite_token: e
      }
    });
  }
  getPrescriptionPatientByProjectId(e) {
    return this.axiosInstance.get(`/project/${e}`);
  }
  getFileUrl(e, t, r) {
    const i = `${this.axiosInstance.defaults.baseURL}project/file`, o = new URL(i);
    o.searchParams.append("file_name", t), o.searchParams.append("project_name", e), r && o.searchParams.append("output_file_name", r);
    const a = this.axiosInstance.defaults.headers.common.Authorization;
    return {
      url: o.toString(),
      headers: a ? { Authorization: a } : {}
    };
  }
  getProductionCenterLiabilityForm(e, t) {
    return this.axiosInstanceJson.get(`weblink/productionCenter/${e}/project/${t}/liabilityForm`, {
      responseType: "blob",
      headers: { Accept: "application/pdf" }
    });
  }
  getProductionCenterCustomLiabilityForm(e, t, r, i) {
    const o = i instanceof Date ? i : i ? new Date(i) : /* @__PURE__ */ new Date(), a = Number.isNaN(o.getTime()) ? /* @__PURE__ */ new Date() : o, s = {
      patientName: t,
      projectName: r,
      lastModified: this.trimMilliseconds(a.toISOString())
    };
    return this.axiosInstanceJson.post(`weblink/productionCenter/${e}/customLiabilityForm`, s, {
      responseType: "blob",
      headers: { Accept: "application/pdf" }
    });
  }
  getProductionCenterAssetUrl(e, t) {
    const r = new URL(`${this.axiosInstance.defaults.baseURL}asset/prodCenterAsset/${e}`);
    return r.searchParams.append("name", t), r.toString();
  }
  async GetProjectByUUID(e) {
    return this.axiosInstanceJson.get(`/project/uuid/${e}`);
  }
  async GetFileByUUID(e, t) {
    return this.axiosInstance.get(`/project/file/${e}`, {
      responseType: "arraybuffer",
      headers: {
        Accept: "application/octet-stream"
      },
      onDownloadProgress: (r) => {
        t && t(r.loaded / r.total);
      }
    });
  }
  getFile(e, t, r) {
    return this.axiosInstance.get("/project/file", {
      params: {
        file_name: t,
        project_name: e
      },
      responseType: "arraybuffer",
      headers: {
        Accept: "application/octet-stream"
      },
      onDownloadProgress: (i) => {
        if (r) {
          const o = Math.round(i.loaded * 100 / i.total);
          r(i.loaded, i.total, o);
        }
      }
    });
  }
  getJsonFile(e, t) {
    return this.axiosInstance.get("/project/file", {
      params: {
        file_name: t,
        project_name: e
      }
    });
  }
  getProjectFileList(e) {
    return this.axiosInstanceJson.get("/project/file/list", {
      params: {
        project_name: e
      }
    });
  }
  getZippedFilesList(e, t) {
    return this.axiosInstance.get("/project/zipper/projectpart/list", {
      params: {
        project_name: e,
        project_file: t
      }
    });
  }
  getProjectFileFromZipByType(e, t, r, i = () => {
  }) {
    return this.axiosInstance.get("/project/zipper/projectpart", {
      params: {
        project_name: e,
        project_file: t,
        file_type: r
      },
      onDownloadProgress: (o) => {
        const a = Math.round(o.loaded * 100 / o.total);
        i(o.loaded, o.total, a);
      }
    });
  }
  getBinaryProjectFileFromZipByType(e, t, r, i = () => {
  }) {
    return this.axiosInstance.get("/project/zipper/projectpart", {
      params: {
        project_name: e,
        project_file: t,
        file_type: r
      },
      responseType: "arraybuffer",
      headers: {
        Accept: "application/octet-stream"
      },
      onDownloadProgress: (o) => {
        const a = Math.round(o.loaded * 100 / o.total);
        i(o.loaded, o.total, a);
      }
    });
  }
  getProjectFileJson(e, t, r, i, o = () => {
  }) {
    return this.axiosInstance.get("/project/zipper/projectpart/json", {
      params: {
        project_name: e,
        project_file: t,
        file_type: r,
        unzipped_id: i || ""
      },
      onDownloadProgress: (a) => {
        const s = Math.round(a.loaded * 100 / a.total);
        o(a.loaded, a.total, s);
      }
    });
  }
  getProjectFileFromZipByIdUrl(e, t, r, i, o) {
    return `project/zipper/projectpart?${new URLSearchParams({
      project_name: e,
      project_file: t,
      unzipped_id: r.toString(),
      ...o && { file_type: o },
      ...i && { output_file_name: i }
    }).toString()}`;
  }
  getProjectFileFromZipByIdFullUrl(e, t, r, i, o) {
    const a = new URL(`${this.axiosInstance.defaults.baseURL}`), s = this.getProjectFileFromZipByIdUrl(e, t, i, o, r);
    return `${a}${s}`;
  }
  getProjectFileFromZipById(e, t, r, i = !0, o) {
    let a = {};
    return i && (a = {
      responseType: "arraybuffer",
      headers: {
        Accept: "application/octet-stream"
      }
    }), this.axiosInstance.get(this.getProjectFileFromZipByIdUrl(e, t, r, void 0, o), {
      ...a
    });
  }
  getProjectFileMetaDataById(e) {
    return this.axiosInstanceJson.get(`/project/file/id/${e}/metadata`);
  }
  addProject(e, t, r, i, o) {
    const a = {
      project_name: e,
      patient_data: t
    };
    return r && (a.project_type = r), this.axiosInstance.post("/project", a);
  }
  addProjectPrescriptionType(e) {
    const t = new FormData();
    return t.append("project_name", e.projectName), t.append("origin_project_name", e.originProjectName), t.append("origin_project_file_name", e.originProjectFileName), t.append("patient_data", e.patientData), this.axiosInstanceJson.post("/project/prescription", t, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  }
  deleteProject(e) {
    const t = {
      project_name: e
    };
    return this.axiosInstance.delete("/project", { data: t });
  }
  deleteProjectBatch(e) {
    return this.axiosInstanceJson.delete("/project/batch", { data: e });
  }
  uploadProjectFile(e, t, r, i, o = () => {
  }) {
    return this.axiosInstance.post(
      "/project/file",
      {
        params: {
          project_name: e,
          project_file: t,
          type: r,
          file: i
        }
      },
      {
        headers: {
          "Content-Type": "multipart/form-data"
        },
        onUploadProgress: (a) => {
          const s = Math.round(a.loaded * 100 / a.total);
          o(a.loaded, a.total, s);
        }
      }
    );
  }
  getAllUsers() {
    return this.axiosInstance.get("/admin/user");
  }
  postUserSettingsKey(e, t) {
    return this.axiosInstance.post(`/weblink/userSettings/${e}`, JSON.stringify(t), { headers: { "Content-Type": "application/json" } });
  }
  getWebhookTriggerList() {
    return this.axiosInstanceJson.get("/webhook/trigger/list");
  }
  getProductionCenterWebhookList(e) {
    return this.axiosInstanceJson.get(`/webhook/productionCenter/${e}/list`);
  }
  postProductionCenterWebhook(e, t) {
    return this.axiosInstanceJson.post(
      `/webhook/productionCenter/${t}`,
      {
        ...e
      },
      {
        params: {
          pcId: t
        }
      }
    );
  }
  deleteProductionCenterWebhook(e, t) {
    return this.axiosInstanceJson.delete(`webhook/productionCenter/${e}/${t}`);
  }
  getProductionCenterUsers(e) {
    return this.axiosInstanceJson.get(`/weblink/productionCenter/${e}/users`);
  }
  getUserAddressesById(e, t) {
    return this.axiosInstanceJson.get(`/weblink/productionCenter/${e}/user/${t}/addresses`);
  }
  addProductionCenterUser(e) {
    return this.axiosInstanceJson.post(`/weblink/productionCenter/${e.id}/user/${e.uid}`);
  }
  addMultiProductionCenterUsers(e) {
    return this.axiosInstanceJson.post(`/weblink/productionCenter/${e.productionCenterId}/user/batch`, e.body);
  }
  removeMultiProductionCenterUsers(e) {
    return this.axiosInstanceJson.delete(`/weblink/productionCenter/${e.productionCenterId}/user/batch`, { data: e.body });
  }
  removeProductionCenterUser(e) {
    return this.axiosInstanceJson.delete(`/weblink/productionCenter/${e.id}/user/${e.uid}`);
  }
  setReadOnlyProductionCenterUser(e) {
    return this.axiosInstanceJson.post(`/weblink/productionCenter/${e.id}/user/${e.uid}`);
  }
  setReadOnlyProductionCenterOperator(e) {
    return this.axiosInstanceJson.post(`/weblink/productionCenter/${e.id}/operator/${e.uid}/readOnly`);
  }
  setProductionCenterOperator(e) {
    return this.axiosInstanceJson.post(`/weblink/productionCenter/${e.pcId}/operator/${e.uId}`, {
      role: e.role,
      permissions: e.permissions
    });
  }
  getUserAddresses() {
    return this.axiosInstance.get("/user/addresses");
  }
  getProductionCenters() {
    return this.axiosInstanceJson.get("/weblink/productionCenter/list");
  }
  getProductionCentersFullInfo() {
    return this.axiosInstanceJson.get("/weblink/productionCenter/list/fullInfo");
  }
  getUsersProductionCenters() {
    return this.axiosInstanceJson.get("/weblink/productionCenter/listMy");
  }
  createProductionCenter(e) {
    return this.axiosInstanceJson.post("/weblink/productionCenter", {
      ...e
    });
  }
  updateProductionCenter(e) {
    return this.axiosInstanceJson.post("/weblink/productionCenter", {
      ...e
    });
  }
  getUsers(e) {
    return this.axiosInstanceJson.get(`/weblink/productionCenter/${e}/operators/search`, {
      params: {
        match: ""
      }
    });
  }
  getUserByKeyword(e, t) {
    return this.axiosInstanceJson.get(`/weblink/productionCenter/${t}/operators/search`, {
      params: {
        match: e
      }
    });
  }
  upsertUserBillingAddress(e) {
    return e.id != 0 ? this.axiosInstanceJson.post(`/user/billingAddr?address_id=${e.id}`, {
      ...e.data
    }) : this.axiosInstanceJson.post("/user/billingAddr", {
      ...e.data
    });
  }
  deleteUserBillingAddress(e) {
    return this.axiosInstance.delete(`/user/billingAddr?address_id=${e}`);
  }
  deleteUserShippingAddress(e) {
    return this.axiosInstance.delete(`/user/shippingAddr?address_id=${e}`);
  }
  updateUserBillingAddress(e) {
    return this.axiosInstance.post(
      "/admin/shippingAddr",
      {
        address_id: e.address_id,
        user_id: e.user_id,
        billing_data: e.billing_data
      },
      { headers: { "Content-Type": "multipart/form-data" } }
    );
  }
  createProductionCenterUserBillingAddress(e) {
    return this.axiosInstanceJson.post(
      `/weblink/productionCenter/${e.productionCenterId}/user/${e.uid}/address/billing`,
      {
        ...e.body
      },
      { transformRequest: void 0 }
    );
  }
  updateProductionCenterUserBillingAddress(e) {
    return this.axiosInstanceJson.post(
      `/weblink/productionCenter/${e.productionCenterId}/user/${e.uid}/address/billing?address_id=${e.aid}`,
      {
        ...e.body
      },
      { transformRequest: void 0 }
    );
  }
  deleteProductionCenterUserBillingAddress(e) {
    return this.axiosInstance.delete(`/weblink/productionCenter/${e.productionCenterId}/address/billing/${e.aid}`);
  }
  verifyProductionCenterUserBillingAddress(e) {
    return this.axiosInstanceJson.post(`/weblink/productionCenter/${e.pcid}/user/${e.uid}/address/billing/verify?address_id=${e.address_id}`);
  }
  createProductionCenterUserShippingAddress(e) {
    return this.axiosInstanceJson.post(
      `/weblink/productionCenter/${e.productionCenterId}/user/${e.uid}/address/shipping`,
      {
        ...e.body
      },
      { transformRequest: void 0 }
    );
  }
  updateProductionCenterUserShippingAddress(e) {
    return this.axiosInstanceJson.post(
      `/weblink/productionCenter/${e.productionCenterId}/user/${e.uid}/address/shipping?address_id=${e.aid}`,
      {
        ...e.body,
        verified: e.verified
      },
      { transformRequest: void 0 }
    );
  }
  verifyProductionCenterUserShippingAddress(e) {
    return this.axiosInstanceJson.post(`/weblink/productionCenter/${e.pcid}/user/${e.uid}/address/shipping/verify?address_id=${e.address_id}`);
  }
  deleteProductionCenterUserShippingAddress(e) {
    return this.axiosInstance.delete(`/weblink/productionCenter/${e.productionCenterId}/address/shipping/${e.aid}`);
  }
  upsertUserShippingAddress(e) {
    return e.id != 0 ? this.axiosInstanceJson.post(
      `/user/shippingAddr?address_id=${e.id}`,
      {
        ...e.data
      },
      { transformRequest: void 0 }
    ) : this.axiosInstanceJson.post(
      "/user/shippingAddr?",
      {
        ...e.data
      },
      { transformRequest: void 0 }
    );
  }
  getPrescriptionInfoById(e, t) {
    return this.axiosInstanceJson.get(`/weblink/productionCenter/${e}/prescription/${t}`);
  }
  createPrescription(e) {
    return this.axiosInstanceJson.post(`/weblink/productionCenter/${e.productionCenterId}/prescription`, {
      projectFileId: e.projectFileId,
      formData: JSON.stringify(e.formData),
      estimatedShippingDate: e.estimatedShippingDate,
      type: 0
    });
  }
  createPrescriptionOrder(e, t) {
    return this.axiosInstanceJson.post(`/weblink/productionCenter/${t}/prescription`, {
      projectFileId: e.projectFileId,
      formData: JSON.stringify(e.formData),
      estimatedShippingDate: e.estimatedShippingDate,
      type: 0,
      projectId: 0,
      notes: e.notes,
      workflowId: e.workflowId,
      projectName: e.projectName,
      customerId: e.customerId,
      patientData: {
        firstName: e.patientData.firstName,
        lastName: e.patientData.lastName,
        notes: e.patientData.notes,
        dateOfBirth: e.patientData.dateOfBirth,
        extra: {
          additionalProp1: e.patientData.extra.additionalProp1,
          additionalProp2: e.patientData.extra.additionalProp2,
          additionalProp3: e.patientData.extra.additionalProp3
        }
      },
      shippingNotes: e.shippingNotes,
      productionNotes: e.productionNotes
    });
  }
  createRealguidePrescription(e, t) {
    const r = e.estimatedShippingDate, i = r ? new Date(r) : void 0, o = !i || isNaN(i.getTime()) || i.getFullYear() <= 2024;
    return this.axiosInstanceJson.post(`/weblink/productionCenter/${t}/prescription/realguide`, {
      projectFileId: e.projectFileId,
      formData: JSON.stringify(e.formData),
      estimatedShippingDate: o ? null : this.adjustForTimezone(new Date(i)),
      caseNumber: "",
      type: 0,
      projectId: 0,
      notes: e.notes,
      workflowId: e.workflowId,
      projectName: "",
      customerId: 0,
      patientData: e.patientData,
      shippingNotes: e.shippingNotes,
      productionNotes: e.productionNotes
    });
  }
  createPrescriptionWithNoAttachment(e, t) {
    const r = e.estimatedShippingDate, i = r ? new Date(r) : void 0, o = !i || isNaN(i.getTime()) || i.getFullYear() <= 2024;
    return this.axiosInstanceJson.post(`/weblink/productionCenter/${t}/prescription/realguide`, {
      formData: JSON.stringify(e.formData),
      estimatedShippingDate: o ? null : this.adjustForTimezone(new Date(i)),
      caseNumber: "",
      type: e.type,
      projectId: e.projectId,
      notes: e.notes,
      workflowId: e.workflowId,
      projectName: e.projectName,
      customerId: e.customerId,
      patientData: e.patientData,
      shippingNotes: e.shippingNotes,
      productionNotes: e.productionNotes,
      ...e.customOwner && { customOwner: e.customOwner }
    });
  }
  createBellatekPrescription(e) {
    return this.axiosInstanceJson.post(`/weblink/productionCenter/${e.productionCenterId}/prescription/bellatek`, {
      projectFileId: e.projectFileId,
      formData: JSON.stringify(e.formData),
      estimatedShippingDate: e.estimatedShippingDate,
      type: 0
    });
  }
  createEmptyPrescription(e) {
    return this.axiosInstanceJson.post(`/weblink/productionCenter/${e.productionCenterId}/prescription`, {
      projectId: e.projectId,
      formData: JSON.stringify(e.formData),
      estimatedShippingDate: e.estimatedShippingDate,
      type: 1
    });
  }
  uploadAttachmentToPrescription(e, t) {
    const r = new FormData();
    return r.append("file_name", e.fileName), r.append("type", e.type), r.append("file", e.file), this.axiosInstanceJson.post(`/weblink/productionCenter/${e.productionCenterId}/prescription/${e.prescriptionId}/attachment`, r, {
      headers: {
        "Content-Type": "multipart/form-data"
      },
      onUploadProgress: (i) => {
        t && t(i.loaded / i.total);
      }
    });
  }
  updatePrescription(e) {
    return e.estimatedShippingDate && (e.estimatedShippingDate = this.adjustForTimezone(e.estimatedShippingDate)), this.axiosInstanceJson.post(`/weblink/productionCenter/${e.productionCenterId}/prescription/${e.prescriptionId}`, {
      formData: e.formData ? JSON.stringify(e.formData) : void 0,
      estimatedShippingDate: e.estimatedShippingDate,
      caseNumber: e.caseId
    });
  }
  archivePrescription(e, t) {
    return this.axiosInstance.post(`/weblink/productionCenter/${e}/prescription/${t}/archive`);
  }
  getProductionCenterInfo(e) {
    return this.axiosInstance.get(`/weblink/productionCenter/${e}/info`);
  }
  getProductionCenterInfoByName(e) {
    return this.axiosInstance.get(`/weblink/productionCenter/info?name=${e}`);
  }
  getProductionCenterInfoByExtension(e) {
    return this.axiosInstance.get(`/weblink/productionCenter/info?extension=${e}`);
  }
  getProductionSteps(e) {
    return this.axiosInstance.get(`/weblink/productionCenter/${e}/steps`);
  }
  getProductionCenterStepHistory(e, t) {
    return this.axiosInstance.get(`/weblink/productionCenter/${e}/prescription/${t}/stepHistory`);
  }
  getProductionCenterStatuses(e) {
    return this.axiosInstance.get(`/weblink/productionCenter/${e}/statuses`);
  }
  getProductionCenterStatusHistory(e, t) {
    return this.axiosInstance.get(`/weblink/productionCenter/${e}/prescription/${t}/statusHistory`, {});
  }
  updateProductionCenterMoveStep(e, t, r) {
    return this.axiosInstanceJson.post(
      `/weblink/productionCenter/${e}/prescription/${t}/moveStep`,
      {
        ...r
      },
      { transformRequest: void 0 }
    );
  }
  updateProductionCenterPiecesMachineStep(e, t, r) {
    return this.axiosInstanceJson.post(
      `/weblink/productionCenter/${e}/prescription/${t}/step`,
      {
        ...r
      },
      { transformRequest: void 0 }
    );
  }
  updateProductionCenterStatus(e, t, r) {
    return this.axiosInstanceJson.post(
      `/weblink/productionCenter/${e}/prescription/${t}/moveStatus`,
      {
        ...r
      },
      { transformRequest: void 0 }
    );
  }
  upsertProductionCenterStatus(e, t) {
    return this.axiosInstanceJson.post(
      `/weblink/productionCenter/${e}/status`,
      {
        ...t
      },
      { transformRequest: void 0 }
    );
  }
  upsertProductionCenterStep(e, t) {
    return this.axiosInstanceJson.post(
      `/weblink/productionCenter/${e}/step`,
      {
        ...t
      },
      { transformRequest: void 0 }
    );
  }
  removeProductionCenterStatus(e, t) {
    return this.axiosInstance.delete(`/weblink/productionCenter/${e}/status/${t}`);
  }
  removeProductionCenterStep(e, t) {
    return this.axiosInstance.delete(`/weblink/productionCenter/${e}/step/${t}`);
  }
  getProductionCenterPrescriptionById(e, t) {
    return this.axiosInstanceJson.get(`/weblink/productionCenter/${e}/prescription/${t}`);
  }
  getProductionCenterPrescriptions(e) {
    return this.axiosInstanceJson.post(`/weblink/productionCenter/${e}/prescriptions`, { pageSize: 5e3 });
  }
  getProductionCenterPrescriptionsSlim(e, t) {
    return this.axiosInstanceJson.post(`/weblink/productionCenter/${e}/prescriptions/slim`, {
      pageSize: t.pageSize,
      archived: t.archived,
      page: t.page,
      connection: t.connection,
      statusId: t.statusId,
      stepIds: t.stepIds,
      assignedOperatorId: t.assignedOperatorId,
      sortColumn: t.sortColumn,
      sortOrder: t.sortOrder,
      searchString: t.searchString,
      ...t.workflow !== null && { workflow: t.workflow }
    });
  }
  getProductionCenterPrescriptionsFat(e, t) {
    return this.axiosInstanceJson.post(`/weblink/productionCenter/${e}/prescriptions/fat`, {
      pageSize: t.pageSize,
      archived: t.archived,
      page: t.page,
      connection: t.connection,
      statusId: t.statusId,
      stepIds: t.stepIds,
      assignedOperatorId: t.assignedOperatorId,
      sortColumn: t.sortColumn,
      sortOrder: t.sortOrder,
      searchString: t.searchString,
      machine: t.machine,
      ...t.workflow !== null && { workflow: t.workflow }
    });
  }
  getProductionCenterOperators(e) {
    return this.axiosInstance.get(`/weblink/productionCenter/${e}/operators`, {});
  }
  addProductionCenterOperator(e, t) {
    return this.axiosInstance.post(`/weblink/productionCenter/${e}/operator/${t}`);
  }
  addProductionCenterOperators(e, t) {
    return this.axiosInstanceJson.post(`/weblink/productionCenter/${e}/operator/batch`, JSON.parse(t));
  }
  removeProductionCenterOperators(e, t) {
    return this.axiosInstanceJson.delete(`/weblink/productionCenter/${e}/operator/batch`, {
      data: JSON.parse(t)
    });
  }
  removeProductionCenterOperator(e, t) {
    return this.axiosInstance.delete(`/weblink/productionCenter/${e}/operator/${t}`);
  }
  updatePrescriptionsOperator(e) {
    return this.axiosInstanceJson.post(
      `/weblink/productionCenter/${e.productionCenterId}/prescription/${e.prescriptionId}/operator?operatorId=${e.operator}`
    );
  }
  removePrescriptionsOperator(e) {
    return this.axiosInstance.delete(`/weblink/productionCenter/${e.productionCenterId}/prescription/${e.prescriptionId}/operator`);
  }
  getProjectNotifications(e) {
    return this.axiosInstance.get("/project/chat", {
      params: {
        project_name: e
      }
    });
  }
  addProjectMediaMessage(e) {
    return this.axiosInstance.post(
      "/project/chat/media",
      {
        project_name: e.projectName,
        channel: e.channel ?? rt.CHAT,
        text: JSON.stringify(e.mediaModel)
      },
      { headers: { "Content-Type": "multipart/form-data" } }
    );
  }
  addProjectMessage(e) {
    return this.axiosInstance.post(
      "/project/chat",
      {
        project_name: e.projectName,
        text: e.text,
        private: e.private ?? !1,
        channel: e.channel
      },
      { headers: { "Content-Type": "multipart/form-data" } }
    );
  }
  shareProject(e) {
    const t = new FormData();
    return t.append("project_name", e.projectName), t.append("with_username", e.withUsername), t.append("message", e.message), t.append("editable", e.editable.toString()), t.append("anonymize", e.anonymize.toString()), this.axiosInstanceJson.post("/project/share", t, { headers: { "Content-Type": "multipart/form-data" } });
  }
  setProjectOwner(e) {
    const t = new FormData();
    return t.append("project_name", e.projectName), t.append("owner", e.owner), this.axiosInstanceJson.post("/project/setOwner", t, { headers: { "Content-Type": "multipart/form-data" } });
  }
  shareProjectFile(e) {
    const t = new FormData();
    return t.append("project_name", e.projectName), t.append("with_username", e.withUsername), t.append("message", e.message), t.append("editable", e.editable.toString()), t.append("anonymize", e.anonymize.toString()), t.append("file_name", e.fileName), t.append("analog_holes", e.analogHoles.toString()), this.axiosInstanceJson.post("/project/file/share", t, { headers: { "Content-Type": "multipart/form-data" } });
  }
  setProjectFileEditableAsPro(e) {
    const t = new FormData();
    return t.append("project_name", e.projectName), t.append("file_name", e.fileName), t.append("editable", e.editable.toString()), this.axiosInstanceJson.post("/project/file/setEditableAsPro", t, {
      headers: { "Content-Type": "multipart/form-data" }
    });
  }
  updateSeenNotifications(e, t) {
    const r = new FormData();
    return r.append("project_id", e.toString()), r.append("client_time", (/* @__PURE__ */ new Date()).toISOString()), r.append("channel", t), this.axiosInstanceJson.post("/project/chat/readMessages", r, { headers: { "Content-Type": "multipart/form-data" } });
  }
  /*** Project notifications End ***/
  async uploadFile(e, t, r, i, o, a, s) {
    const u = {
      file_name: t,
      project_name: e,
      type: r,
      file: i,
      local_create_date: a ?? (/* @__PURE__ */ new Date()).toISOString()
    };
    u.local_create_date = this.trimMilliseconds(u.local_create_date);
    const f = s ?? { format: "json" };
    return u.metadata = typeof f == "string" ? f : JSON.stringify(f), this.axiosInstance.post("/project/file", u, {
      onUploadProgress: (l) => {
        if (o) {
          const c = l.total ?? 0, p = c > 0 ? l.loaded / c : 0;
          o(p);
        }
      }
    });
  }
  async uploadMetadataToProject(e, t, r) {
    const i = {
      project_name: e,
      file_name: t,
      local_create_date: (/* @__PURE__ */ new Date()).toISOString()
    };
    i.local_create_date = this.trimMilliseconds(i.local_create_date);
    const o = r ?? { format: "json" };
    return i.metadata = typeof o == "string" ? o : JSON.stringify(o), this.axiosInstance.post("/project/file/metadata", i);
  }
  async copyFileBetweenProjects(e) {
    const t = new FormData();
    return t.append("source_project_name", e.sourceProjectName), t.append("source_file_name", e.sourceFileName), t.append("target_project_name", e.targetProjectName), t.append("target_file_name", e.targetFileName), t.append("target_metadata", e.targetMetadata), t.append("target_type", e.targetType), t.append("force", String(e.force)), this.axiosInstanceJson.post("/project/file/copy/betweenProjects", t, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  }
  async copyProject(e, t, r, i) {
    return this.axiosInstance.post("/project/file/copy/files", {
      project_name: e,
      file_name: t,
      new_file_name: r,
      ...i && { override_mobile_type: i }
    });
  }
  async acceptPrescriptionRevision(e, t, r) {
    return this.axiosInstanceJson.get(`/weblink/productionCenter/${e}/prescription/${t}/revision/${r}/accept`);
  }
  async uploadSingleJsonFile(e, t, r, i, o, a) {
    return this.axiosInstance.post(
      "/project/zipper/projectpart/json",
      {
        part_name: t,
        project_file: t + ".zip",
        project_name: e,
        file_type: r,
        file: i,
        local_create_date: a ?? (/* @__PURE__ */ new Date()).toISOString()
      },
      {
        onUploadProgress: (s) => {
          o && o(s.loaded / s.total);
        }
      }
    );
  }
  async uploadSingleBinFile(e, t, r, i, o, a, s) {
    return this.axiosInstance.post(
      "/project/zipper/projectpart",
      {
        part_name: r,
        project_file: t + ".zip",
        project_name: e,
        file_type: i,
        file: o,
        local_create_date: s ?? (/* @__PURE__ */ new Date()).toISOString()
      },
      {
        onUploadProgress: (u) => {
          a && a(u.loaded / u.total);
        }
      }
    );
  }
  async uploadSingleFile(e, t, r, i, o, a) {
    return this.axiosInstance.post(
      "/project/zipper/projectpart",
      {
        part_name: t,
        project_file: t + ".zip",
        project_name: e,
        file_type: r,
        file: i,
        local_create_date: a ?? (/* @__PURE__ */ new Date()).toISOString()
      },
      {
        onUploadProgress: (s) => {
          o && o(s.loaded / s.total);
        }
      }
    );
  }
  async uploadProjectPartsBatch(e, t, r, i, o) {
    const a = new FormData();
    return a.append("project_file", t + ".zip"), a.append("project_name", e), r.forEach((s) => {
      a.append("file", new File([s.file], s.part_name + "." + s.file_type));
    }), this.axiosInstanceJson.post("/project/zipper/projectpart/batch", a, {
      headers: {
        "Content-Type": "multipart/form-data"
      },
      onUploadProgress: (s) => {
        i && i(s.loaded / s.total);
      }
    });
  }
  async deleteSingleFile(e, t, r) {
    const i = {
      part: r,
      project_file: t + ".zip",
      project_name: e
    };
    return this.axiosInstance.delete("/project/zipper/projectpart/batch", { data: i });
  }
  async deleteProjectPartsBatch(e, t, r) {
    let i = "/project/zipper/projectpart/batch";
    i += "?project_name=" + e, i += "&project_file=" + t + ".zip";
    for (const o of r)
      i += "&id=" + o;
    return this.axiosInstance.delete(i);
  }
  deleteProjectFile(e, t) {
    const r = {
      file_name: t,
      project_name: e
    };
    return this.axiosInstance.delete("/project/file", { data: r });
  }
  /*** Production center materials Start ***/
  getProductionCenterMaterialById(e, t) {
    return this.axiosInstance.get(`/weblink/productionCenter/${t}/material/${e}`, {});
  }
  upsertProductionCenterMaterial(e, t) {
    return this.axiosInstanceJson.post(
      `/weblink/productionCenter/${t}/material`,
      {
        ...e
      },
      { transformRequest: void 0 }
    );
  }
  deleteProductionCenterMaterial(e, t) {
    return this.axiosInstance.delete(`/weblink/productionCenter/${t}/material/${e}`);
  }
  getProductionCenterMaterialPool(e, t) {
    return this.axiosInstance.get(`/weblink/productionCenter/${e}/json`, {
      params: {
        pool: t
      }
    });
  }
  upsertProductionCenterMaterialPool(e, t) {
    return this.axiosInstanceJson.post(
      `/weblink/productionCenter/${t}/json`,
      {
        ...e
      },
      { transformRequest: void 0 }
    );
  }
  deleteProductionCenterMaterialPool(e, t) {
    return this.axiosInstance.delete(`/weblink/productionCenter/${t}/json/${e}`);
  }
  /*** Production center materials End ***/
  getProdcutionCenterAssets(e) {
    return this.axiosInstance.get(`/asset/prodCenterAsset/${e.prod_center_id}`, {
      params: {
        name: e.name
      },
      responseType: "json",
      headers: {
        Accept: "application/octet-stream"
      }
    });
  }
  deleteProdCenterAsset(e) {
    return this.axiosInstanceJson.delete(`/asset/prodCenterAsset/${e.prod_center_id}`, {
      headers: { "Content-Type": "multipart/form-data" },
      data: {
        name: e.name
      }
    });
  }
  insertProductionCenterAsset(e, t) {
    return this.axiosInstance.post(
      `/asset/prodCenterAsset/${e.prod_center_id}`,
      {
        file: e.file,
        name: e.name
      },
      {
        onUploadProgress: (r) => {
          t && t(r.loaded / r.total);
        }
      }
    );
  }
  uploadPoolAsset(e, t, r) {
    const i = new FormData();
    return i.append("file", t), i.append("name", t.name ?? "test_filename.json"), i.append("pool", e), this.axiosInstanceJson.post("/asset", i, {
      headers: {
        "Content-Type": "multipart/form-data"
      },
      onUploadProgress: (o) => {
        r && r(o.loaded / o.total);
      }
    });
  }
  getPoolAsset(e, t, r, i) {
    return this.axiosInstance.get("/asset", {
      params: {
        pool: e,
        name: t
      },
      responseType: r ? "arraybuffer" : "json",
      headers: {
        Accept: "application/octet-stream"
      },
      onDownloadProgress: (o) => {
        i && i(o.loaded / o.total);
      }
    });
  }
  deletePoolAsset(e, t) {
    return this.axiosInstanceJson.delete("/asset", {
      headers: { "Content-Type": "multipart/form-data" },
      data: {
        pool: e,
        name: t
      }
    });
  }
  getPoolAssetList(e) {
    return this.axiosInstanceJson.get("/asset/list", {
      params: {
        pool: e
      }
    });
  }
  getUserMessageCountByProdCenter() {
    return this.axiosInstanceJson.get("/weblink/messageCountByProdCenter");
  }
  updateUserNotificationsPrescriptionUpdate(e) {
    return this.axiosInstanceJson.get("/weblink/settings/email", {
      params: {
        statuses: e.toString()
      }
    });
  }
  updateUserChatNotificationsUpdate(e) {
    return this.axiosInstanceJson.get("/weblink/settings/chatemails", {
      params: {
        value: e
      }
    });
  }
  updateWeblinkNotificationSettings(e, t) {
    return this.axiosInstanceJson.put(`/weblink/productionCenter/${e}/settings/notifications`, {
      ...t
    });
  }
  getWeblinkNotificationSettings(e) {
    return this.axiosInstanceJson.get(`/weblink/productionCenter/${e}/settings/notifications`);
  }
  getUsersDoctorList() {
    return this.axiosInstanceJson.get("/user/doctor/list");
  }
  upsertDoctor(e) {
    return this.axiosInstanceJson.post("/user/doctor", {
      id: e.id,
      firstName: e.firstName,
      lastName: e.lastName,
      uid: e.uid
    });
  }
  upsertDoctorRecord(e, t) {
    return this.axiosInstanceJson.post(`/user/doctor/project/${t}/assign`, {
      id: e.id,
      firstName: e.firstName,
      lastName: e.lastName,
      uid: e.uid
    });
  }
  exportToAlfred(e) {
    return this.axiosInstanceJson.post("idi", e);
  }
  deleteDoctor(e) {
    return this.axiosInstanceJson.delete(`user/doctor/${e}`);
  }
  getUserSessionToken() {
    return this.axiosInstanceJson.get("/user/sessionToken");
  }
  getVendorInfo() {
    return this.axiosInstanceJson.get("/info/vendor");
  }
  getInfoUrls(e) {
    const t = { kinds: e };
    return this.axiosInstanceJson.post("/info/urls", t);
  }
  setUserTimezone(e) {
    return this.axiosInstanceJson.post("user/timezone", e, {
      headers: {
        "Content-Type": "text/plain",
        Accept: "application/json"
      }
    });
  }
  adjustForTimezone(e) {
    const t = e.getTimezoneOffset() * 6e4;
    return e.setTime(e.getTime() + Math.abs(t)), e;
  }
  trimMilliseconds(e) {
    return e.replace(/,\d{3}$/, "");
  }
  /*** Workflows START ***/
  getWorkflows(e, t = !1) {
    return this.axiosInstanceJson.get(`/weblink/productionCenter/${e}/workflow/list`, {
      params: {
        all: t
      }
    });
  }
  getAvailableWorkflows(e) {
    return this.axiosInstanceJson.get(`/weblink/workflows/available?fileId=${e}`);
  }
  upsertWorkflow(e, t) {
    return this.axiosInstanceJson.post(`/weblink/productionCenter/${e}/workflow`, t);
  }
  deleteWorkflow(e, t) {
    return this.axiosInstanceJson.delete(`/weblink/productionCenter/${e}/workflow/${t}`);
  }
  moveProductionCenterWorkflowsStatus(e, t, r) {
    return this.axiosInstanceJson.post(`/weblink/productionCenter/${e}/workflow/status/${t}?direction=${r}`);
  }
  upsertWorkflowStatus(e, t) {
    return this.axiosInstanceJson.post(`/weblink/productionCenter/${t}/workflow/status`, e);
  }
  deleteWorkflowStatus(e, t) {
  }
  getWorkflowSteps(e, t) {
    return this.axiosInstanceJson.get(`/weblink/productionCenter/${e}/workflow/${t}/steps`);
  }
  upsertWorkflowStep(e, t, r) {
    return this.axiosInstanceJson.post(`/weblink/productionCenter/${t}/workflow/${r}/step`, e);
  }
  deleteWorkflowStep(e, t) {
  }
  getWorkflowTypeList() {
    return this.axiosInstanceJson.get("weblink/workflow/types");
  }
  updateWorkflowMoveStatus(e, t, r) {
    return this.axiosInstanceJson.post(
      `/weblink/productionCenter/${e}/prescription/${t}/moveWorkflowStatus`,
      {
        ...r
      },
      { transformRequest: void 0 }
    );
  }
  updateWorkflowMoveStep(e, t, r) {
    return this.axiosInstanceJson.post(
      `/weblink/productionCenter/${e}/prescription/${t}/moveWorkflowStep`,
      {
        ...r
      },
      { transformRequest: void 0 }
    );
  }
  /*** Workflows END ***/
}
class Zt {
  constructor(e, t = e) {
    _(this, "axiosInstance");
    _(this, "axiosInstanceJson");
    this.axiosInstance = e, this.axiosInstanceJson = t;
  }
  login(e, t, r, i, o, a, s) {
    const u = {
      username: e,
      password: t,
      client_platform: "web",
      ...i && { client_module: i },
      ...a && { client_build_date: a },
      ...s && { client_device_id: s },
      ...s && { client_version: o },
      ...r && { production_center_id: r }
    };
    return this.axiosInstance.post("/user/login", u);
  }
  logout(e) {
    return this.axiosInstance.post("/user/logout", {
      headers: {
        Authorization: `Bearer ${e}`
      }
    });
  }
  checkSession(e, t, r) {
    return this.axiosInstance.get("/user/session", {
      params: {
        ...t && { production_center_id: t },
        ...r && { client_module: r }
      },
      headers: {
        Authorization: `Bearer ${e}`
      }
    });
  }
  getLoginToken() {
    return this.axiosInstance.get("/user/sessionToken");
  }
  getSessionFromToken(e) {
    return this.axiosInstance.post(`/user/tokenLogin?auth_token=${e}`);
  }
  requestPasswordReset(e) {
    return this.axiosInstance.post("/user/requestPasswordReset", {
      username: e
    });
  }
  updateUserData(e) {
    return this.axiosInstanceJson.post("/user/data", {
      data: JSON.stringify(e)
    });
  }
}
var mt = /* @__PURE__ */ ((n) => (n.Ffff80 = "#ffff80", n.The6666Bb = "#6666bb", n))(mt || {}), gt = /* @__PURE__ */ ((n) => (n.Document = "document", n.Minxml = "minxml", n.Mobile = "mobile", n.Project = "project", n.ProjectReconstruction = "project_reconstruction", n.Image = "image", n.ProjectAttachment = "project_attachment", n.ProjectAttachmentPreview = "project_attachment_preview", n.STL = "stl", n.STL_Preview = "thumb", n.STL_Texture = "stl_texture", n.SVG_Preview = "thumb", n.SegmentationData = "segmentation-data", n.ProcessingData = "processing-data", n.LiabilityForm = "liability_form", n.LiablityPDF = "liability_pdf", n))(gt || {}), It = /* @__PURE__ */ ((n) => (n.ADMIN = "ADMIN", n.OPERATOR = "OPERATOR", n.READONLY_OPERATOR = "READONLY_OPERATOR", n.USER = "USER", n))(It || {}), wt = /* @__PURE__ */ ((n) => (n.EDIT_WORKFLOWS = "EDIT_WORKFLOWS", n.EDIT_MATERIAL_LIB = "EDIT_MATERIAL_LIB", n.EDIT_USERS = "EDIT_USERS", n))(wt || {}), bt = /* @__PURE__ */ ((n) => (n.ADMIN = "Admin", n.OPERATOR = "Operator", n.OPERATOR_READONLY = "Operator readonly", n.USER = "User", n))(bt || {}), Ct = /* @__PURE__ */ ((n) => (n.EDIT_WORKFLOWS = "Edit workflows", n.EDIT_USERS = "Edit users", n.EDIT_MATERIAL_LIB = "Edit material library", n))(Ct || {});
function Xt() {
  return {
    id: 0,
    useDate: /* @__PURE__ */ new Date(),
    data: {
      firstName: "",
      lastName: "",
      organization: "",
      address1: "",
      address2: "",
      city: "",
      zip: "",
      state: "",
      country: "",
      telephone: "",
      optionLabel: void 0
      // Optional field
    },
    bellatekAddressType: 0,
    verified: !1
  };
}
function Gt() {
  return {
    id: 0,
    useDate: /* @__PURE__ */ new Date(),
    data: {
      firstName: "",
      lastName: "",
      organization: "",
      address1: "",
      address2: "",
      city: "",
      zip: "",
      state: "",
      country: "",
      telephone: "",
      vatNumber: "",
      otherTaxNumber: "",
      optionLabel: void 0
      // Optional field
    },
    verified: !1,
    bellatekAddressType: 0
  };
}
var vt = /* @__PURE__ */ ((n) => (n[n.Reconstruction = 0] = "Reconstruction", n[n.RealGUIDE = 1] = "RealGUIDE", n[n.Attachment = 2] = "Attachment", n.Prescription = "prescription", n))(vt || {}), xt = /* @__PURE__ */ ((n) => (n[n.OK = 200] = "OK", n[n.NOT_FOUND = 404] = "NOT_FOUND", n[n.INTERNAL_SERVER_ERROR = 500] = "INTERNAL_SERVER_ERROR", n))(xt || {}), yt = /* @__PURE__ */ ((n) => (n.WEBLINK = "weblink", n.PLANNER = "planner", n))(yt || {}), Pt = /* @__PURE__ */ ((n) => (n.ASC = "ASC", n.DESC = "DESC", n))(Pt || {});
function Yt(n) {
  return {
    archived: !1,
    pageSize: n,
    page: 1,
    sortColumn: "received",
    workflow: "",
    sortOrder: "DESC",
    searchString: ""
  };
}
function Qt(n) {
  return {
    archived: !1,
    pageSize: n,
    page: 1,
    sortColumn: "received",
    sortOrder: "DESC",
    searchString: ""
  };
}
function qt() {
  return {
    billingData: {
      id: 0,
      useDate: /* @__PURE__ */ new Date(),
      data: {
        firstName: "",
        lastName: "",
        organization: "",
        address1: "",
        address2: "",
        city: "",
        zip: "",
        state: "",
        country: "",
        telephone: "",
        vatNumber: "",
        otherTaxNumber: ""
      },
      bellatekAddressType: 0
    },
    shippingData: {
      id: 0,
      useDate: /* @__PURE__ */ new Date(),
      data: {
        firstName: "",
        lastName: "",
        organization: "",
        address1: "",
        address2: "",
        city: "",
        zip: "",
        state: "",
        country: "",
        telephone: ""
      },
      bellatekAddressType: 0
    },
    info: {
      caseNumber: "0",
      estimatedShippingDate: /* @__PURE__ */ new Date(),
      assignedToMe: !1
    },
    orderOptions: {
      customerId: "",
      licenseEmail: "",
      notes: "",
      accountNumber: "",
      referringClinicianZip: "",
      orderOptions: "",
      selectedOrderOption: "",
      bellaCheckCoupon1: "",
      bellaCheckCoupon2: "",
      bellaCheckCoupon3: "",
      additionalBellaChecks: !1,
      productionNotes: "",
      shippingNotes: "",
      pieces: 0,
      machine: "",
      multiMachine: !1
    },
    isCreatePrescriptionForm: !0
  };
}
function er() {
  return {
    firstName: "",
    lastName: "",
    notes: "",
    dateOfBirth: /* @__PURE__ */ new Date(),
    // Default to current date (should be updated when used)
    extra: {
      patientName: void 0,
      // Optional fields
      modality: void 0,
      patientID: void 0,
      doctorID: void 0,
      study_instance_UID: void 0,
      description: void 0
    }
  };
}
function tr(n) {
  return {
    firstName: n ?? "Empty Patient",
    lastName: n ?? "",
    notes: "",
    dateOfBirth: /* @__PURE__ */ new Date(),
    extra: {
      additionalProp1: "",
      additionalProp2: "",
      additionalProp3: ""
    }
  };
}
function rr() {
  return {
    name: "",
    username: "",
    id: 0
  };
}
function _t(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
var F = { exports: {} }, z, xe;
function nt() {
  return xe || (xe = 1, z = function(e, t) {
    return function() {
      for (var i = new Array(arguments.length), o = 0; o < i.length; o++)
        i[o] = arguments[o];
      return e.apply(t, i);
    };
  }), z;
}
var W, ye;
function x() {
  if (ye) return W;
  ye = 1;
  var n = nt(), e = Object.prototype.toString, t = /* @__PURE__ */ (function(d) {
    return function(m) {
      var I = e.call(m);
      return d[I] || (d[I] = I.slice(8, -1).toLowerCase());
    };
  })(/* @__PURE__ */ Object.create(null));
  function r(d) {
    return d = d.toLowerCase(), function(I) {
      return t(I) === d;
    };
  }
  function i(d) {
    return Array.isArray(d);
  }
  function o(d) {
    return typeof d > "u";
  }
  function a(d) {
    return d !== null && !o(d) && d.constructor !== null && !o(d.constructor) && typeof d.constructor.isBuffer == "function" && d.constructor.isBuffer(d);
  }
  var s = r("ArrayBuffer");
  function u(d) {
    var m;
    return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? m = ArrayBuffer.isView(d) : m = d && d.buffer && s(d.buffer), m;
  }
  function f(d) {
    return typeof d == "string";
  }
  function l(d) {
    return typeof d == "number";
  }
  function c(d) {
    return d !== null && typeof d == "object";
  }
  function p(d) {
    if (t(d) !== "object")
      return !1;
    var m = Object.getPrototypeOf(d);
    return m === null || m === Object.prototype;
  }
  var g = r("Date"), C = r("File"), b = r("Blob"), w = r("FileList");
  function y(d) {
    return e.call(d) === "[object Function]";
  }
  function A(d) {
    return c(d) && y(d.pipe);
  }
  function j(d) {
    var m = "[object FormData]";
    return d && (typeof FormData == "function" && d instanceof FormData || e.call(d) === m || y(d.toString) && d.toString() === m);
  }
  var E = r("URLSearchParams");
  function h(d) {
    return d.trim ? d.trim() : d.replace(/^\s+|\s+$/g, "");
  }
  function R() {
    return typeof navigator < "u" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS") ? !1 : typeof window < "u" && typeof document < "u";
  }
  function T(d, m) {
    if (!(d === null || typeof d > "u"))
      if (typeof d != "object" && (d = [d]), i(d))
        for (var I = 0, D = d.length; I < D; I++)
          m.call(null, d[I], I, d);
      else
        for (var v in d)
          Object.prototype.hasOwnProperty.call(d, v) && m.call(null, d[v], v, d);
  }
  function k() {
    var d = {};
    function m(v, P) {
      p(d[P]) && p(v) ? d[P] = k(d[P], v) : p(v) ? d[P] = k({}, v) : i(v) ? d[P] = v.slice() : d[P] = v;
    }
    for (var I = 0, D = arguments.length; I < D; I++)
      T(arguments[I], m);
    return d;
  }
  function J(d, m, I) {
    return T(m, function(v, P) {
      I && typeof v == "function" ? d[P] = n(v, I) : d[P] = v;
    }), d;
  }
  function L(d) {
    return d.charCodeAt(0) === 65279 && (d = d.slice(1)), d;
  }
  function U(d, m, I, D) {
    d.prototype = Object.create(m.prototype, D), d.prototype.constructor = d, I && Object.assign(d.prototype, I);
  }
  function S(d, m, I) {
    var D, v, P, ve = {};
    m = m || {};
    do {
      for (D = Object.getOwnPropertyNames(d), v = D.length; v-- > 0; )
        P = D[v], ve[P] || (m[P] = d[P], ve[P] = !0);
      d = Object.getPrototypeOf(d);
    } while (d && (!I || I(d, m)) && d !== Object.prototype);
    return m;
  }
  function N(d, m, I) {
    d = String(d), (I === void 0 || I > d.length) && (I = d.length), I -= m.length;
    var D = d.indexOf(m, I);
    return D !== -1 && D === I;
  }
  function O(d) {
    if (!d) return null;
    var m = d.length;
    if (o(m)) return null;
    for (var I = new Array(m); m-- > 0; )
      I[m] = d[m];
    return I;
  }
  var M = /* @__PURE__ */ (function(d) {
    return function(m) {
      return d && m instanceof d;
    };
  })(typeof Uint8Array < "u" && Object.getPrototypeOf(Uint8Array));
  return W = {
    isArray: i,
    isArrayBuffer: s,
    isBuffer: a,
    isFormData: j,
    isArrayBufferView: u,
    isString: f,
    isNumber: l,
    isObject: c,
    isPlainObject: p,
    isUndefined: o,
    isDate: g,
    isFile: C,
    isBlob: b,
    isFunction: y,
    isStream: A,
    isURLSearchParams: E,
    isStandardBrowserEnv: R,
    forEach: T,
    merge: k,
    extend: J,
    trim: h,
    stripBOM: L,
    inherits: U,
    toFlatObject: S,
    kindOf: t,
    kindOfTest: r,
    endsWith: N,
    toArray: O,
    isTypedArray: M,
    isFileList: w
  }, W;
}
var H, Pe;
function it() {
  if (Pe) return H;
  Pe = 1;
  var n = x();
  function e(t) {
    return encodeURIComponent(t).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
  }
  return H = function(r, i, o) {
    if (!i)
      return r;
    var a;
    if (o)
      a = o(i);
    else if (n.isURLSearchParams(i))
      a = i.toString();
    else {
      var s = [];
      n.forEach(i, function(l, c) {
        l === null || typeof l > "u" || (n.isArray(l) ? c = c + "[]" : l = [l], n.forEach(l, function(g) {
          n.isDate(g) ? g = g.toISOString() : n.isObject(g) && (g = JSON.stringify(g)), s.push(e(c) + "=" + e(g));
        }));
      }), a = s.join("&");
    }
    if (a) {
      var u = r.indexOf("#");
      u !== -1 && (r = r.slice(0, u)), r += (r.indexOf("?") === -1 ? "?" : "&") + a;
    }
    return r;
  }, H;
}
var V, _e;
function St() {
  if (_e) return V;
  _e = 1;
  var n = x();
  function e() {
    this.handlers = [];
  }
  return e.prototype.use = function(r, i, o) {
    return this.handlers.push({
      fulfilled: r,
      rejected: i,
      synchronous: o ? o.synchronous : !1,
      runWhen: o ? o.runWhen : null
    }), this.handlers.length - 1;
  }, e.prototype.eject = function(r) {
    this.handlers[r] && (this.handlers[r] = null);
  }, e.prototype.forEach = function(r) {
    n.forEach(this.handlers, function(o) {
      o !== null && r(o);
    });
  }, V = e, V;
}
var K, Se;
function Dt() {
  if (Se) return K;
  Se = 1;
  var n = x();
  return K = function(t, r) {
    n.forEach(t, function(o, a) {
      a !== r && a.toUpperCase() === r.toUpperCase() && (t[r] = o, delete t[a]);
    });
  }, K;
}
var Z, De;
function $() {
  if (De) return Z;
  De = 1;
  var n = x();
  function e(i, o, a, s, u) {
    Error.call(this), this.message = i, this.name = "AxiosError", o && (this.code = o), a && (this.config = a), s && (this.request = s), u && (this.response = u);
  }
  n.inherits(e, Error, {
    toJSON: function() {
      return {
        // Standard
        message: this.message,
        name: this.name,
        // Microsoft
        description: this.description,
        number: this.number,
        // Mozilla
        fileName: this.fileName,
        lineNumber: this.lineNumber,
        columnNumber: this.columnNumber,
        stack: this.stack,
        // Axios
        config: this.config,
        code: this.code,
        status: this.response && this.response.status ? this.response.status : null
      };
    }
  });
  var t = e.prototype, r = {};
  return [
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED"
    // eslint-disable-next-line func-names
  ].forEach(function(i) {
    r[i] = { value: i };
  }), Object.defineProperties(e, r), Object.defineProperty(t, "isAxiosError", { value: !0 }), e.from = function(i, o, a, s, u, f) {
    var l = Object.create(t);
    return n.toFlatObject(i, l, function(p) {
      return p !== Error.prototype;
    }), e.call(l, i.message, o, a, s, u), l.name = i.name, f && Object.assign(l, f), l;
  }, Z = e, Z;
}
var X, Re;
function ot() {
  return Re || (Re = 1, X = {
    silentJSONParsing: !0,
    forcedJSONParsing: !0,
    clarifyTimeoutError: !1
  }), X;
}
var G, Ae;
function at() {
  if (Ae) return G;
  Ae = 1;
  var n = x();
  function e(t, r) {
    r = r || new FormData();
    var i = [];
    function o(s) {
      return s === null ? "" : n.isDate(s) ? s.toISOString() : n.isArrayBuffer(s) || n.isTypedArray(s) ? typeof Blob == "function" ? new Blob([s]) : Buffer.from(s) : s;
    }
    function a(s, u) {
      if (n.isPlainObject(s) || n.isArray(s)) {
        if (i.indexOf(s) !== -1)
          throw Error("Circular reference detected in " + u);
        i.push(s), n.forEach(s, function(l, c) {
          if (!n.isUndefined(l)) {
            var p = u ? u + "." + c : c, g;
            if (l && !u && typeof l == "object") {
              if (n.endsWith(c, "{}"))
                l = JSON.stringify(l);
              else if (n.endsWith(c, "[]") && (g = n.toArray(l))) {
                g.forEach(function(C) {
                  !n.isUndefined(C) && r.append(p, o(C));
                });
                return;
              }
            }
            a(l, p);
          }
        }), i.pop();
      } else
        r.append(u, o(s));
    }
    return a(t), r;
  }
  return G = e, G;
}
var Y, je;
function Rt() {
  if (je) return Y;
  je = 1;
  var n = $();
  return Y = function(t, r, i) {
    var o = i.config.validateStatus;
    !i.status || !o || o(i.status) ? t(i) : r(new n(
      "Request failed with status code " + i.status,
      [n.ERR_BAD_REQUEST, n.ERR_BAD_RESPONSE][Math.floor(i.status / 100) - 4],
      i.config,
      i.request,
      i
    ));
  }, Y;
}
var Q, Oe;
function At() {
  if (Oe) return Q;
  Oe = 1;
  var n = x();
  return Q = n.isStandardBrowserEnv() ? (
    // Standard browser envs support document.cookie
    /* @__PURE__ */ (function() {
      return {
        write: function(r, i, o, a, s, u) {
          var f = [];
          f.push(r + "=" + encodeURIComponent(i)), n.isNumber(o) && f.push("expires=" + new Date(o).toGMTString()), n.isString(a) && f.push("path=" + a), n.isString(s) && f.push("domain=" + s), u === !0 && f.push("secure"), document.cookie = f.join("; ");
        },
        read: function(r) {
          var i = document.cookie.match(new RegExp("(^|;\\s*)(" + r + ")=([^;]*)"));
          return i ? decodeURIComponent(i[3]) : null;
        },
        remove: function(r) {
          this.write(r, "", Date.now() - 864e5);
        }
      };
    })()
  ) : (
    // Non standard browser env (web workers, react-native) lack needed support.
    /* @__PURE__ */ (function() {
      return {
        write: function() {
        },
        read: function() {
          return null;
        },
        remove: function() {
        }
      };
    })()
  ), Q;
}
var q, Ne;
function jt() {
  return Ne || (Ne = 1, q = function(e) {
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
  }), q;
}
var ee, ke;
function Ot() {
  return ke || (ke = 1, ee = function(e, t) {
    return t ? e.replace(/\/+$/, "") + "/" + t.replace(/^\/+/, "") : e;
  }), ee;
}
var te, Ee;
function st() {
  if (Ee) return te;
  Ee = 1;
  var n = jt(), e = Ot();
  return te = function(r, i) {
    return r && !n(i) ? e(r, i) : i;
  }, te;
}
var re, $e;
function Nt() {
  if ($e) return re;
  $e = 1;
  var n = x(), e = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
  ];
  return re = function(r) {
    var i = {}, o, a, s;
    return r && n.forEach(r.split(`
`), function(f) {
      if (s = f.indexOf(":"), o = n.trim(f.substr(0, s)).toLowerCase(), a = n.trim(f.substr(s + 1)), o) {
        if (i[o] && e.indexOf(o) >= 0)
          return;
        o === "set-cookie" ? i[o] = (i[o] ? i[o] : []).concat([a]) : i[o] = i[o] ? i[o] + ", " + a : a;
      }
    }), i;
  }, re;
}
var ne, Te;
function kt() {
  if (Te) return ne;
  Te = 1;
  var n = x();
  return ne = n.isStandardBrowserEnv() ? (
    // Standard browser envs have full support of the APIs needed to test
    // whether the request URL is of the same origin as current location.
    (function() {
      var t = /(msie|trident)/i.test(navigator.userAgent), r = document.createElement("a"), i;
      function o(a) {
        var s = a;
        return t && (r.setAttribute("href", s), s = r.href), r.setAttribute("href", s), {
          href: r.href,
          protocol: r.protocol ? r.protocol.replace(/:$/, "") : "",
          host: r.host,
          search: r.search ? r.search.replace(/^\?/, "") : "",
          hash: r.hash ? r.hash.replace(/^#/, "") : "",
          hostname: r.hostname,
          port: r.port,
          pathname: r.pathname.charAt(0) === "/" ? r.pathname : "/" + r.pathname
        };
      }
      return i = o(window.location.href), function(s) {
        var u = n.isString(s) ? o(s) : s;
        return u.protocol === i.protocol && u.host === i.host;
      };
    })()
  ) : (
    // Non standard browser envs (web workers, react-native) lack needed support.
    /* @__PURE__ */ (function() {
      return function() {
        return !0;
      };
    })()
  ), ne;
}
var ie, Ue;
function B() {
  if (Ue) return ie;
  Ue = 1;
  var n = $(), e = x();
  function t(r) {
    n.call(this, r ?? "canceled", n.ERR_CANCELED), this.name = "CanceledError";
  }
  return e.inherits(t, n, {
    __CANCEL__: !0
  }), ie = t, ie;
}
var oe, Je;
function Et() {
  return Je || (Je = 1, oe = function(e) {
    var t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
    return t && t[1] || "";
  }), oe;
}
var ae, Le;
function Fe() {
  if (Le) return ae;
  Le = 1;
  var n = x(), e = Rt(), t = At(), r = it(), i = st(), o = Nt(), a = kt(), s = ot(), u = $(), f = B(), l = Et();
  return ae = function(p) {
    return new Promise(function(C, b) {
      var w = p.data, y = p.headers, A = p.responseType, j;
      function E() {
        p.cancelToken && p.cancelToken.unsubscribe(j), p.signal && p.signal.removeEventListener("abort", j);
      }
      n.isFormData(w) && n.isStandardBrowserEnv() && delete y["Content-Type"];
      var h = new XMLHttpRequest();
      if (p.auth) {
        var R = p.auth.username || "", T = p.auth.password ? unescape(encodeURIComponent(p.auth.password)) : "";
        y.Authorization = "Basic " + btoa(R + ":" + T);
      }
      var k = i(p.baseURL, p.url);
      h.open(p.method.toUpperCase(), r(k, p.params, p.paramsSerializer), !0), h.timeout = p.timeout;
      function J() {
        if (h) {
          var S = "getAllResponseHeaders" in h ? o(h.getAllResponseHeaders()) : null, N = !A || A === "text" || A === "json" ? h.responseText : h.response, O = {
            data: N,
            status: h.status,
            statusText: h.statusText,
            headers: S,
            config: p,
            request: h
          };
          e(function(d) {
            C(d), E();
          }, function(d) {
            b(d), E();
          }, O), h = null;
        }
      }
      if ("onloadend" in h ? h.onloadend = J : h.onreadystatechange = function() {
        !h || h.readyState !== 4 || h.status === 0 && !(h.responseURL && h.responseURL.indexOf("file:") === 0) || setTimeout(J);
      }, h.onabort = function() {
        h && (b(new u("Request aborted", u.ECONNABORTED, p, h)), h = null);
      }, h.onerror = function() {
        b(new u("Network Error", u.ERR_NETWORK, p, h, h)), h = null;
      }, h.ontimeout = function() {
        var N = p.timeout ? "timeout of " + p.timeout + "ms exceeded" : "timeout exceeded", O = p.transitional || s;
        p.timeoutErrorMessage && (N = p.timeoutErrorMessage), b(new u(
          N,
          O.clarifyTimeoutError ? u.ETIMEDOUT : u.ECONNABORTED,
          p,
          h
        )), h = null;
      }, n.isStandardBrowserEnv()) {
        var L = (p.withCredentials || a(k)) && p.xsrfCookieName ? t.read(p.xsrfCookieName) : void 0;
        L && (y[p.xsrfHeaderName] = L);
      }
      "setRequestHeader" in h && n.forEach(y, function(N, O) {
        typeof w > "u" && O.toLowerCase() === "content-type" ? delete y[O] : h.setRequestHeader(O, N);
      }), n.isUndefined(p.withCredentials) || (h.withCredentials = !!p.withCredentials), A && A !== "json" && (h.responseType = p.responseType), typeof p.onDownloadProgress == "function" && h.addEventListener("progress", p.onDownloadProgress), typeof p.onUploadProgress == "function" && h.upload && h.upload.addEventListener("progress", p.onUploadProgress), (p.cancelToken || p.signal) && (j = function(S) {
        h && (b(!S || S && S.type ? new f() : S), h.abort(), h = null);
      }, p.cancelToken && p.cancelToken.subscribe(j), p.signal && (p.signal.aborted ? j() : p.signal.addEventListener("abort", j))), w || (w = null);
      var U = l(k);
      if (U && ["http", "https", "file"].indexOf(U) === -1) {
        b(new u("Unsupported protocol " + U + ":", u.ERR_BAD_REQUEST, p));
        return;
      }
      h.send(w);
    });
  }, ae;
}
var se, Be;
function $t() {
  return Be || (Be = 1, se = null), se;
}
var ce, Me;
function Ce() {
  if (Me) return ce;
  Me = 1;
  var n = x(), e = Dt(), t = $(), r = ot(), i = at(), o = {
    "Content-Type": "application/x-www-form-urlencoded"
  };
  function a(l, c) {
    !n.isUndefined(l) && n.isUndefined(l["Content-Type"]) && (l["Content-Type"] = c);
  }
  function s() {
    var l;
    return (typeof XMLHttpRequest < "u" || typeof process < "u" && Object.prototype.toString.call(process) === "[object process]") && (l = Fe()), l;
  }
  function u(l, c, p) {
    if (n.isString(l))
      try {
        return (c || JSON.parse)(l), n.trim(l);
      } catch (g) {
        if (g.name !== "SyntaxError")
          throw g;
      }
    return (p || JSON.stringify)(l);
  }
  var f = {
    transitional: r,
    adapter: s(),
    transformRequest: [function(c, p) {
      if (e(p, "Accept"), e(p, "Content-Type"), n.isFormData(c) || n.isArrayBuffer(c) || n.isBuffer(c) || n.isStream(c) || n.isFile(c) || n.isBlob(c))
        return c;
      if (n.isArrayBufferView(c))
        return c.buffer;
      if (n.isURLSearchParams(c))
        return a(p, "application/x-www-form-urlencoded;charset=utf-8"), c.toString();
      var g = n.isObject(c), C = p && p["Content-Type"], b;
      if ((b = n.isFileList(c)) || g && C === "multipart/form-data") {
        var w = this.env && this.env.FormData;
        return i(b ? { "files[]": c } : c, w && new w());
      } else if (g || C === "application/json")
        return a(p, "application/json"), u(c);
      return c;
    }],
    transformResponse: [function(c) {
      var p = this.transitional || f.transitional, g = p && p.silentJSONParsing, C = p && p.forcedJSONParsing, b = !g && this.responseType === "json";
      if (b || C && n.isString(c) && c.length)
        try {
          return JSON.parse(c);
        } catch (w) {
          if (b)
            throw w.name === "SyntaxError" ? t.from(w, t.ERR_BAD_RESPONSE, this, null, this.response) : w;
        }
      return c;
    }],
    /**
     * A timeout in milliseconds to abort a request. If set to 0 (default) a
     * timeout is not created.
     */
    timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
      FormData: $t()
    },
    validateStatus: function(c) {
      return c >= 200 && c < 300;
    },
    headers: {
      common: {
        Accept: "application/json, text/plain, */*"
      }
    }
  };
  return n.forEach(["delete", "get", "head"], function(c) {
    f.headers[c] = {};
  }), n.forEach(["post", "put", "patch"], function(c) {
    f.headers[c] = n.merge(o);
  }), ce = f, ce;
}
var de, ze;
function Tt() {
  if (ze) return de;
  ze = 1;
  var n = x(), e = Ce();
  return de = function(r, i, o) {
    var a = this || e;
    return n.forEach(o, function(u) {
      r = u.call(a, r, i);
    }), r;
  }, de;
}
var ue, We;
function ct() {
  return We || (We = 1, ue = function(e) {
    return !!(e && e.__CANCEL__);
  }), ue;
}
var pe, He;
function Ut() {
  if (He) return pe;
  He = 1;
  var n = x(), e = Tt(), t = ct(), r = Ce(), i = B();
  function o(a) {
    if (a.cancelToken && a.cancelToken.throwIfRequested(), a.signal && a.signal.aborted)
      throw new i();
  }
  return pe = function(s) {
    o(s), s.headers = s.headers || {}, s.data = e.call(
      s,
      s.data,
      s.headers,
      s.transformRequest
    ), s.headers = n.merge(
      s.headers.common || {},
      s.headers[s.method] || {},
      s.headers
    ), n.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      function(l) {
        delete s.headers[l];
      }
    );
    var u = s.adapter || r.adapter;
    return u(s).then(function(l) {
      return o(s), l.data = e.call(
        s,
        l.data,
        l.headers,
        s.transformResponse
      ), l;
    }, function(l) {
      return t(l) || (o(s), l && l.response && (l.response.data = e.call(
        s,
        l.response.data,
        l.response.headers,
        s.transformResponse
      ))), Promise.reject(l);
    });
  }, pe;
}
var le, Ve;
function dt() {
  if (Ve) return le;
  Ve = 1;
  var n = x();
  return le = function(t, r) {
    r = r || {};
    var i = {};
    function o(c, p) {
      return n.isPlainObject(c) && n.isPlainObject(p) ? n.merge(c, p) : n.isPlainObject(p) ? n.merge({}, p) : n.isArray(p) ? p.slice() : p;
    }
    function a(c) {
      if (n.isUndefined(r[c])) {
        if (!n.isUndefined(t[c]))
          return o(void 0, t[c]);
      } else return o(t[c], r[c]);
    }
    function s(c) {
      if (!n.isUndefined(r[c]))
        return o(void 0, r[c]);
    }
    function u(c) {
      if (n.isUndefined(r[c])) {
        if (!n.isUndefined(t[c]))
          return o(void 0, t[c]);
      } else return o(void 0, r[c]);
    }
    function f(c) {
      if (c in r)
        return o(t[c], r[c]);
      if (c in t)
        return o(void 0, t[c]);
    }
    var l = {
      url: s,
      method: s,
      data: s,
      baseURL: u,
      transformRequest: u,
      transformResponse: u,
      paramsSerializer: u,
      timeout: u,
      timeoutMessage: u,
      withCredentials: u,
      adapter: u,
      responseType: u,
      xsrfCookieName: u,
      xsrfHeaderName: u,
      onUploadProgress: u,
      onDownloadProgress: u,
      decompress: u,
      maxContentLength: u,
      maxBodyLength: u,
      beforeRedirect: u,
      transport: u,
      httpAgent: u,
      httpsAgent: u,
      cancelToken: u,
      socketPath: u,
      responseEncoding: u,
      validateStatus: f
    };
    return n.forEach(Object.keys(t).concat(Object.keys(r)), function(p) {
      var g = l[p] || a, C = g(p);
      n.isUndefined(C) && g !== f || (i[p] = C);
    }), i;
  }, le;
}
var fe, Ke;
function ut() {
  return Ke || (Ke = 1, fe = {
    version: "0.27.2"
  }), fe;
}
var he, Ze;
function Jt() {
  if (Ze) return he;
  Ze = 1;
  var n = ut().version, e = $(), t = {};
  ["object", "boolean", "number", "function", "string", "symbol"].forEach(function(o, a) {
    t[o] = function(u) {
      return typeof u === o || "a" + (a < 1 ? "n " : " ") + o;
    };
  });
  var r = {};
  t.transitional = function(a, s, u) {
    function f(l, c) {
      return "[Axios v" + n + "] Transitional option '" + l + "'" + c + (u ? ". " + u : "");
    }
    return function(l, c, p) {
      if (a === !1)
        throw new e(
          f(c, " has been removed" + (s ? " in " + s : "")),
          e.ERR_DEPRECATED
        );
      return s && !r[c] && (r[c] = !0, console.warn(
        f(
          c,
          " has been deprecated since v" + s + " and will be removed in the near future"
        )
      )), a ? a(l, c, p) : !0;
    };
  };
  function i(o, a, s) {
    if (typeof o != "object")
      throw new e("options must be an object", e.ERR_BAD_OPTION_VALUE);
    for (var u = Object.keys(o), f = u.length; f-- > 0; ) {
      var l = u[f], c = a[l];
      if (c) {
        var p = o[l], g = p === void 0 || c(p, l, o);
        if (g !== !0)
          throw new e("option " + l + " must be " + g, e.ERR_BAD_OPTION_VALUE);
        continue;
      }
      if (s !== !0)
        throw new e("Unknown option " + l, e.ERR_BAD_OPTION);
    }
  }
  return he = {
    assertOptions: i,
    validators: t
  }, he;
}
var me, Xe;
function Lt() {
  if (Xe) return me;
  Xe = 1;
  var n = x(), e = it(), t = St(), r = Ut(), i = dt(), o = st(), a = Jt(), s = a.validators;
  function u(f) {
    this.defaults = f, this.interceptors = {
      request: new t(),
      response: new t()
    };
  }
  return u.prototype.request = function(l, c) {
    typeof l == "string" ? (c = c || {}, c.url = l) : c = l || {}, c = i(this.defaults, c), c.method ? c.method = c.method.toLowerCase() : this.defaults.method ? c.method = this.defaults.method.toLowerCase() : c.method = "get";
    var p = c.transitional;
    p !== void 0 && a.assertOptions(p, {
      silentJSONParsing: s.transitional(s.boolean),
      forcedJSONParsing: s.transitional(s.boolean),
      clarifyTimeoutError: s.transitional(s.boolean)
    }, !1);
    var g = [], C = !0;
    this.interceptors.request.forEach(function(R) {
      typeof R.runWhen == "function" && R.runWhen(c) === !1 || (C = C && R.synchronous, g.unshift(R.fulfilled, R.rejected));
    });
    var b = [];
    this.interceptors.response.forEach(function(R) {
      b.push(R.fulfilled, R.rejected);
    });
    var w;
    if (!C) {
      var y = [r, void 0];
      for (Array.prototype.unshift.apply(y, g), y = y.concat(b), w = Promise.resolve(c); y.length; )
        w = w.then(y.shift(), y.shift());
      return w;
    }
    for (var A = c; g.length; ) {
      var j = g.shift(), E = g.shift();
      try {
        A = j(A);
      } catch (h) {
        E(h);
        break;
      }
    }
    try {
      w = r(A);
    } catch (h) {
      return Promise.reject(h);
    }
    for (; b.length; )
      w = w.then(b.shift(), b.shift());
    return w;
  }, u.prototype.getUri = function(l) {
    l = i(this.defaults, l);
    var c = o(l.baseURL, l.url);
    return e(c, l.params, l.paramsSerializer);
  }, n.forEach(["delete", "get", "head", "options"], function(l) {
    u.prototype[l] = function(c, p) {
      return this.request(i(p || {}, {
        method: l,
        url: c,
        data: (p || {}).data
      }));
    };
  }), n.forEach(["post", "put", "patch"], function(l) {
    function c(p) {
      return function(C, b, w) {
        return this.request(i(w || {}, {
          method: l,
          headers: p ? {
            "Content-Type": "multipart/form-data"
          } : {},
          url: C,
          data: b
        }));
      };
    }
    u.prototype[l] = c(), u.prototype[l + "Form"] = c(!0);
  }), me = u, me;
}
var ge, Ge;
function Ft() {
  if (Ge) return ge;
  Ge = 1;
  var n = B();
  function e(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    var r;
    this.promise = new Promise(function(a) {
      r = a;
    });
    var i = this;
    this.promise.then(function(o) {
      if (i._listeners) {
        var a, s = i._listeners.length;
        for (a = 0; a < s; a++)
          i._listeners[a](o);
        i._listeners = null;
      }
    }), this.promise.then = function(o) {
      var a, s = new Promise(function(u) {
        i.subscribe(u), a = u;
      }).then(o);
      return s.cancel = function() {
        i.unsubscribe(a);
      }, s;
    }, t(function(a) {
      i.reason || (i.reason = new n(a), r(i.reason));
    });
  }
  return e.prototype.throwIfRequested = function() {
    if (this.reason)
      throw this.reason;
  }, e.prototype.subscribe = function(r) {
    if (this.reason) {
      r(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(r) : this._listeners = [r];
  }, e.prototype.unsubscribe = function(r) {
    if (this._listeners) {
      var i = this._listeners.indexOf(r);
      i !== -1 && this._listeners.splice(i, 1);
    }
  }, e.source = function() {
    var r, i = new e(function(a) {
      r = a;
    });
    return {
      token: i,
      cancel: r
    };
  }, ge = e, ge;
}
var Ie, Ye;
function Bt() {
  return Ye || (Ye = 1, Ie = function(e) {
    return function(r) {
      return e.apply(null, r);
    };
  }), Ie;
}
var we, Qe;
function Mt() {
  if (Qe) return we;
  Qe = 1;
  var n = x();
  return we = function(t) {
    return n.isObject(t) && t.isAxiosError === !0;
  }, we;
}
var qe;
function zt() {
  if (qe) return F.exports;
  qe = 1;
  var n = x(), e = nt(), t = Lt(), r = dt(), i = Ce();
  function o(s) {
    var u = new t(s), f = e(t.prototype.request, u);
    return n.extend(f, t.prototype, u), n.extend(f, u), f.create = function(c) {
      return o(r(s, c));
    }, f;
  }
  var a = o(i);
  return a.Axios = t, a.CanceledError = B(), a.CancelToken = Ft(), a.isCancel = ct(), a.VERSION = ut().version, a.toFormData = at(), a.AxiosError = $(), a.Cancel = a.CanceledError, a.all = function(u) {
    return Promise.all(u);
  }, a.spread = Bt(), a.isAxiosError = Mt(), F.exports = a, F.exports.default = a, F.exports;
}
var be, et;
function Wt() {
  return et || (et = 1, be = zt()), be;
}
var Ht = Wt();
const pt = /* @__PURE__ */ _t(Ht);
function nr(n) {
  return pt.create({
    baseURL: n,
    paramsSerializer: (e) => {
      let t = "";
      return Object.keys(e).forEach((r) => {
        t += `${r}=${encodeURIComponent(e[r])}&`;
      }), t.substring(0, t.length - 1);
    },
    transformRequest: [
      function(e, t) {
        if (!e)
          return e;
        if (t && t["Content-Type"] === "application/json")
          return typeof e == "object" ? JSON.stringify(e) : e;
        const r = new FormData();
        return Object.keys(e).forEach(function(i) {
          r.append(i, e[i]);
        }), r;
      }
    ]
  });
}
function ir(n) {
  return pt.create({
    baseURL: n,
    paramsSerializer: (e) => {
      let t = "";
      return Object.keys(e).forEach((r) => {
        t += `${r}=${encodeURIComponent(e[r])}&`;
      }), t.substring(0, t.length - 1);
    }
  });
}
function or() {
  return {
    machine: "",
    multiMachine: !1,
    pieces: 0,
    productionNotes: "",
    shippingNotes: "",
    customerId: "",
    licenseEmail: "",
    notes: "",
    accountNumber: "",
    zbEELaccount: void 0,
    // Optional field
    referringClinicianZip: "",
    orderOptions: "",
    selectedOrderOption: "",
    bellaCheckCoupon1: "",
    bellaCheckCoupon2: "",
    bellaCheckCoupon3: "",
    additionalBellaChecks: !1,
    info: {
      caseNumber: void 0
      // Optional field
    }
  };
}
var tt;
((n) => {
  ((t) => {
    t[t.PIN = 0] = "PIN", t[t.IMPLANT = 1] = "IMPLANT";
  })(n.SleeveType || (n.SleeveType = {}));
  class e {
    constructor(r) {
      _(this, "axiosInstance");
      this.axiosInstance = r;
    }
    getAllObjects() {
      return this.axiosInstance.get("/stlLib/getFullSTL");
    }
    getSTLFile(r) {
      return this.axiosInstance.get("/stlLib/file/", {
        responseType: "arraybuffer",
        params: {
          file: r
        }
      });
    }
  }
  n.STLLibraryAPI = e;
})(tt || (tt = {}));
class ar {
  constructor(e, t) {
    _(this, "pingTimeout", -1);
    _(this, "ws");
    _(this, "eventHandlers", []);
    _(this, "closedByUser", !1);
    _(this, "reconnectAttempt", 0);
    _(this, "reconnectDelaysMs");
    _(this, "reconnectOnUnauthorized");
    _(this, "baseApiUrl");
    this.baseApiUrl = e, this.reconnectDelaysMs = t == null ? void 0 : t.reconnectDelaysMs, this.reconnectOnUnauthorized = (t == null ? void 0 : t.reconnectOnUnauthorized) ?? !1;
  }
  openConnection() {
    this.closedByUser = !1, this.initConnection(this.baseApiUrl);
  }
  initConnection(e) {
    this.ws = new WebSocket(`${e}`), this.ws.onopen = () => {
      console.log("WebSocketAPI: connected OK!"), this.reconnectAttempt = 0, this.pingTimeout = setInterval(() => {
        this.ws.send("ping"), console.log("WebSocketAPI: Ping sent to server");
      }, 5e3);
    }, this.ws.onclose = (t) => {
      var a;
      clearInterval(this.pingTimeout);
      const r = (a = t.reason) == null ? void 0 : a.toLowerCase(), i = r === "unauthorized" || t.code === 1008 && !r, o = !i || this.reconnectOnUnauthorized;
      if (!this.closedByUser && o) {
        const s = this.getReconnectDelayMs();
        if (s === null) {
          console.warn("WebSocketAPI: connection closed, reconnect limit reached", {
            code: t.code,
            reason: t.reason,
            wasClean: t.wasClean
          });
          return;
        }
        console.log("WebSocketAPI: connection closed, reconnecting...", {
          code: t.code,
          reason: t.reason,
          wasClean: t.wasClean,
          reconnectDelay: s,
          reconnectAttempt: this.reconnectAttempt
        }), setTimeout(() => {
          this.initConnection(e);
        }, s);
      } else i && (console.warn("WebSocketAPI: connection closed (unauthorized), not reconnecting", {
        code: t.code,
        reason: t.reason,
        wasClean: t.wasClean
      }), this.closedByUser = !0);
    }, this.ws.onmessage = (t) => {
      this.eventHandlers.forEach((r) => {
        r(t);
      });
    };
  }
  getReconnectDelayMs() {
    if (!this.reconnectDelaysMs)
      return 2e3;
    if (this.reconnectAttempt >= this.reconnectDelaysMs.length)
      return null;
    const e = this.reconnectDelaysMs[this.reconnectAttempt];
    return this.reconnectAttempt += 1, e;
  }
  closeConnection() {
    this.closedByUser = !0, this.ws.close();
  }
  addEventHandler(e) {
    this.eventHandlers.push(e);
  }
  removeEventHandler(e) {
    this.eventHandlers = this.eventHandlers.filter((t) => t !== e);
  }
}
export {
  Zt as AuthAPI,
  mt as ColorCode,
  ht as DIRECTION,
  rt as NotificationChannelType,
  wt as OperatorPermissionsEnum,
  It as OperatorRoleEnum,
  gt as ProjectFileType,
  vt as ProjectType,
  xt as ResponseStatusEnum,
  tt as STLLibrary,
  Kt as ServerAPI,
  Pt as SortOrder,
  yt as WebCADModule,
  ar as WebSocketAPI,
  Ct as WeblinkPermissions,
  bt as WeblinkRole,
  nr as createAxiosInstance,
  ir as createAxiosInstanceWithoutURLencoding,
  qt as createPrescriptionFormModel,
  Gt as getDefaultBillingData,
  er as getDefaultPatientData,
  tr as getDefaultPatientDataForOrder,
  or as getDefaultPrescriptionOrderOptions,
  Xt as getDefaultShippingData,
  Yt as getNewDataTableModel,
  rr as getNewOperator,
  Qt as getUserDataTableModel
};
//# sourceMappingURL=medic-api.js.map
